import { render, staticRenderFns } from "./master-withdraw-index.vue?vue&type=template&id=baffaf8a"
import script from "./master-withdraw-index.vue?vue&type=script&lang=js"
export * from "./master-withdraw-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports